export default "__VITE_ASSET__CjS6tJdT__"